import React, { useCallback, useEffect, useMemo, useState } from "react";

import MainLayout from "../components/mainLayout";

import { api } from "../api";

import "../sass/pages/gestaoPontoScreen.scss";

import SelectFuncionario from "../components/ui/selectFuncionario.jsx";

// util

const pad2 = (n) => String(n).padStart(2, "0");

const isHHmm = (v) =>

  v === "" || /^([01]\d|2[0-3]):[0-5]\d$/.test(String(v || ""));

const CAMPOS = [

  { key: "EntradaManha", label: "Entrada Manhã" },

  { key: "SaidaManha", label: "Saída Manhã" },

  { key: "EntradaTarde", label: "Entrada Tarde" },

  { key: "SaidaTarde", label: "Saída Tarde" },

  { key: "EntradaExtra", label: "Entrada Extra" },

  { key: "SaidaExtra", label: "Saída Extra" },

];

function getStatus(row) {

  if (!row) return { text: "Sem registro", cls: "semregistro" };

  const em = (row.EntradaManha || "").trim();

  const sm = (row.SaidaManha || "").trim();

  const et = (row.EntradaTarde || "").trim();

  const st = (row.SaidaTarde || "").trim();

  const completo = !!em && !!sm && !!et && !!st;

  const temAlgo =

    !!em ||

    !!sm ||

    !!et ||

    !!st ||

    !!(row.EntradaExtra || "").trim() ||

    !!(row.SaidaExtra || "").trim();

  if (completo) return { text: "Completo", cls: "completo" };

  if (temAlgo) return { text: "Pendente", cls: "pendente" };

  return { text: "Sem registro", cls: "semregistro" };

}

function getFilenameFromDisposition(disposition) {

  if (!disposition) return null;

  const m = /filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i.exec(disposition);

  return m?.[2] ? decodeURIComponent(m[2]) : null;

}

function decodeArrayBufferToText(buf) {

  try {

    return new TextDecoder("utf-8").decode(new Uint8Array(buf));

  } catch {

    return "";

  }

}

function downloadArrayBuffer({ data, contentType, filename }) {

  const blob = new Blob(

    [data],

    { type: contentType || "application/octet-stream" }

  );

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");

  a.href = url;

  a.download = filename || "download";

  document.body.appendChild(a);

  a.click();

  a.remove();

  window.URL.revokeObjectURL(url);

}

function firstDayOfMonth(year, month) {

  return `${year}-${String(month).padStart(2, "0")}-01`;

}

function lastDayOfMonth(year, month) {

  return new Date(year, month, 0).toISOString().slice(0, 10);

}

function resolveCodFunc(obj) {

  return (

    Number(obj?.CodFunc_New ?? obj?.CodFunc ?? obj?.IdFuncionario ?? obj?.id) ||

    null

  );

}

function resolveCodCadFunc(obj) {

  return Number(obj?.CodCadFunc ?? obj?.CodCad ?? obj?.CodCad_New) || null;

}

function resolveNomeFunc(obj) {

  return String(obj?.Nome ?? obj?.NomeFunc ?? obj?.Usuario ?? "").trim() || "Funcionário";

}

function getExtByFormato(formato) {

  const fmt = String(formato || "").toUpperCase();

  if (fmt === "PDF") return "pdf";

  if (fmt === "XLSX") return "xlsx";

  if (fmt === "TXT") return "txt";

  return "csv";

}

function getAcceptHeaderByFormato(formato) {

  const fmt = String(formato || "").toUpperCase();

  if (fmt === "PDF") return "application/pdf, application/octet-stream";

  if (fmt === "XLSX") {

    return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream";

  }

  if (fmt === "TXT") {

    return "text/plain, application/octet-stream";

  }

  return "text/csv, application/octet-stream";

}

/* =========================

   Modal

========================= */

function Modal({ open, title, message, kind = "info", details, onClose }) {

  if (!open) return null;

  const cls =

    kind === "error"

      ? "gp-modal is-error"

      : kind === "success"

      ? "gp-modal is-success"

      : "gp-modal";

  return (

    <div

      className={cls}

      role="dialog"

      aria-modal="true"

      onMouseDown={(e) => {

        if (e.target === e.currentTarget) onClose?.();

      }}

    >

      <div className="gp-modal__backdrop" />

      <div className="gp-modal__panel">

        <div className="gp-modal__title">

  <div className="gp-modal__h">{title || "Aviso"}</div>

  <button className="gp-modal__close" onClick={onClose} type="button">

    Fechar

  </button>

</div>

        <div className="gp-modal__body">

          <div className="gp-modal__desc">{message || "Sem mensagem."}</div>

          {details ? (

            <pre className="gp-modal__pre" title="Detalhes técnicos">

              {details}

            </pre>

          ) : null}

        </div>

        <div className="gp-modal__actions">

  <button className="gp-modal__confirm" onClick={onClose} type="button">

    OK

  </button>

</div>

      </div>

    </div>

  );

}

export default function GestaoPontoScreen() {

  const now = new Date();

  const [func, setFunc] = useState(null);

  // competência

  const [mes, setMes] = useState(pad2(now.getMonth() + 1));

  const [ano, setAno] = useState(String(now.getFullYear()));

  // dados mês

  const [loading, setLoading] = useState(false);

  const [rowsMes, setRowsMes] = useState([]);

  const [diaSel, setDiaSel] = useState(null);

  // edição no detalhe

  const [edit, setEdit] = useState({ campo: null, valor: "" });

  const [justificativa, setJustificativa] = useState("");

  const [saving, setSaving] = useState(false);

  // export

  const [exporting, setExporting] = useState(false);

  const [selectedExportFuncs, setSelectedExportFuncs] = useState([]);

  const [exportAllMonth, setExportAllMonth] = useState(false);

  // modal

  const [modal, setModal] = useState({

    open: false,

    title: "",

    message: "",

    kind: "info",

    details: "",

  });

  const openModal = useCallback((title, message, kind = "info", details = "") => {

    setModal({ open: true, title, message, kind, details });

  }, []);

  const closeModal = useCallback(() => {

    setModal((s) => ({ ...s, open: false }));

  }, []);

  // resolve ids

  const codFunc = resolveCodFunc(func);

  const codCadFunc = resolveCodCadFunc(func);

  const nomeFunc = resolveNomeFunc(func);

  const totalDias = useMemo(() => {

    const y = Number(ano);

    const m = Number(mes);

    if (!y || !m) return 0;

    return new Date(y, m, 0).getDate();

  }, [mes, ano]);

  const mapByDia = useMemo(() => {

    const mp = new Map();

    for (const r of rowsMes) {

      const d = Number(r.Dia);

      if (!Number.isFinite(d)) continue;

      if (!mp.has(d)) mp.set(d, r);

    }

    return mp;

  }, [rowsMes]);

  const dias = useMemo(() => {

    const y = Number(ano);

    const m = Number(mes);

    if (!y || !m || !totalDias) return [];

    return Array.from({ length: totalDias }, (_, i) => {

      const dia = i + 1;

      const dt = new Date(y, m - 1, dia);

      const dow = dt.getDay();

      const row = mapByDia.get(dia) || null;

      const status = getStatus(row);

      return {

        dia,

        isWeekend: dow === 0 || dow === 6,

        row,

        status,

      };

    });

  }, [ano, mes, totalDias, mapByDia]);

  const diaAtual = useMemo(() => {

    if (!diaSel) return null;

    return dias.find((d) => d.dia === diaSel) || null;

  }, [dias, diaSel]);

  const getErrMsg = useCallback((e) => {

    const d = e?.response?.data;

    if (d && typeof d === "object") {

      return d?.mensagem || d?.message || d?.error || "Erro desconhecido";

    }

    return e?.message || "Erro desconhecido";

  }, []);

  const loadMes = useCallback(async () => {

    if (!codFunc) return;

    setLoading(true);

    try {

      const { data } = await api.get(`/ponto/${codFunc}`, {

        params: { mes, ano, page: 1, limit: 500 },

      });

      setRowsMes(Array.isArray(data?.data) ? data.data : []);

    } catch (e) {

      console.error(e);

      setRowsMes([]);

      openModal("Falha", "Falha ao carregar mês.", "error", getErrMsg(e));

    } finally {

      setLoading(false);

    }

  }, [codFunc, mes, ano, openModal, getErrMsg]);

  useEffect(() => {

    setDiaSel(null);

    setEdit({ campo: null, valor: "" });

    if (codFunc) loadMes();

    else setRowsMes([]);

  }, [codFunc, mes, ano, loadMes]);

  const startEdit = useCallback(

    (campo) => {

      if (!diaAtual) return;

      const current = String(diaAtual?.row?.[campo] || "").slice(0, 5);

      setEdit({ campo, valor: current });

    },

    [diaAtual]

  );

  const cancelEdit = useCallback(() => setEdit({ campo: null, valor: "" }), []);

  const addFuncionarioToExport = useCallback(() => {

    if (!codFunc) {

      openModal("Atenção", "Selecione um funcionário antes de adicionar.", "info");

      return;

    }

    setSelectedExportFuncs((prev) => {

      const exists = prev.some((x) => x.codFunc === codFunc);

      if (exists) return prev;

      return [

        ...prev,

        {

          codFunc,

          codCadFunc: codCadFunc || null,

          nome: nomeFunc,

        },

      ];

    });

    openModal(

      "Seleção atualizada",

      `Funcionário "${nomeFunc}" adicionado à fila de exportação.`,

      "success"

    );

  }, [codFunc, codCadFunc, nomeFunc, openModal]);

  const removeFuncionarioFromExport = useCallback((cod) => {

    setSelectedExportFuncs((prev) => prev.filter((x) => x.codFunc !== cod));

  }, []);

  const clearExportSelection = useCallback(() => {

    setSelectedExportFuncs([]);

    setExportAllMonth(false);

  }, []);

  const save = useCallback(async () => {

    if (!codFunc) return openModal("Atenção", "Selecione um funcionário.", "info");

    if (!diaSel) return openModal("Atenção", "Selecione um dia.", "info");

    if (!edit.campo) return;

    const h = String(edit.valor || "").trim();

    if (!isHHmm(h)) {

      return openModal("Validação", "Hora inválida. Use HH:mm.", "info");

    }

    if (!String(justificativa || "").trim()) {

      return openModal("Validação", "Justificativa é obrigatória.", "info");

    }

    setSaving(true);

    try {

      let existente = null;

      try {

        const vr = await api.get(

          `/ponto/verifica/${codFunc}/${diaSel}/${Number(mes)}/${Number(ano)}`

        );

        existente = vr?.data || null;

      } catch {

        existente = null;

      }

      const payloadUpsert = {

        NomeFunc: nomeFunc,

        CodFunc: codFunc,

        CodCadFunc: codCadFunc || null,

        dia: Number(diaSel),

        mes: Number(mes),

        ano: Number(ano),

        campo: edit.campo,

        hora: h,

        motivo: String(justificativa).trim(),

        ajustadoPor:

          sessionStorage.getItem("Usuario") ||

          sessionStorage.getItem("login") ||

          "web",

      };

      if (existente?.ID) {

        try {

          await api.patch(`/ponto/ajustar/${existente.ID}`, {

            ajustes: { [edit.campo]: h },

            justificativa: String(justificativa).trim(),

          });

        } catch (ePatch) {

          console.error("PATCH falhou, fallback PUT /ponto/ajustar:", ePatch);

          await api.put(`/ponto/ajustar`, payloadUpsert);

        }

      } else {

        await api.put(`/ponto/ajustar`, payloadUpsert);

      }

      cancelEdit();

      await loadMes();

      openModal("Sucesso", "Ajuste aplicado com sucesso.", "success");

    } catch (e) {

      console.error(e);

      openModal("Falha", `Falha ao salvar ajuste: ${getErrMsg(e)}`, "error");

    } finally {

      setSaving(false);

    }

  }, [

    codFunc,

    diaSel,

    edit.campo,

    edit.valor,

    justificativa,

    mes,

    ano,

    nomeFunc,

    codCadFunc,

    cancelEdit,

    loadMes,

    openModal,

    getErrMsg,

  ]);

  const carregarFuncionariosComRegistroNoMes = useCallback(async () => {

    const mm = Number(mes);

    const yy = Number(ano);

    const dtIni = firstDayOfMonth(yy, mm);

    const dtFim = lastDayOfMonth(yy, mm);

    let page = 1;

    const limit = 500;

    let total = 0;

    const collected = [];

    do {

      const { data } = await api.get(`/ponto/gestao`, {

        params: {

          dtIni,

          dtFim,

          page,

          limit,

        },

      });

      const rows = Array.isArray(data?.data) ? data.data : [];

      total = Number(data?.total || 0);

      collected.push(...rows);

      page += 1;

    } while ((page - 1) * limit < total);

    const uniq = new Map();

    for (const r of collected) {

      const cod = Number(r?.CodFunc);

      if (!Number.isFinite(cod)) continue;

      if (!uniq.has(cod)) {

        uniq.set(cod, {

          codFunc: cod,

          nome: String(r?.NomeFunc || `Funcionário ${cod}`).trim(),

        });

      }

    }

    return Array.from(uniq.values());

  }, [mes, ano]);

  const exportar = useCallback(

    async (formato) => {

      setExporting(true);

      try {

        const fmt = String(formato || "PDF").toUpperCase();

        const ext = getExtByFormato(fmt);

        let funcionariosIds = [];

        let rotuloExportacao = "";

        if (exportAllMonth) {

          const lista = await carregarFuncionariosComRegistroNoMes();

          funcionariosIds = lista

            .map((x) => Number(x.codFunc))

            .filter(Number.isFinite);

          rotuloExportacao = `Todos os funcionários com registro em ${mes}/${ano}`;

          if (!funcionariosIds.length) {

            throw new Error(

              `Nenhum funcionário com registro encontrado em ${mes}/${ano}.`

            );

          }

        } else {

          funcionariosIds = selectedExportFuncs

            .map((x) => Number(x.codFunc))

            .filter(Number.isFinite);

          if (!funcionariosIds.length && codFunc) {

            funcionariosIds = [Number(codFunc)];

            rotuloExportacao = nomeFunc;

          } else if (funcionariosIds.length === 1) {

            const achado = selectedExportFuncs.find(

              (x) => Number(x.codFunc) === funcionariosIds[0]

            );

            rotuloExportacao = achado?.nome || `CodFunc ${funcionariosIds[0]}`;

          } else {

            rotuloExportacao = `${funcionariosIds.length} funcionário(s)`;

          }

          if (!funcionariosIds.length) {

            return openModal(

              "Atenção",

              "Selecione um funcionário, adicione à fila de exportação ou marque a opção de todos do mês.",

              "info"

            );

          }

        }

        const payload = {

          formato: fmt,

          tipo: "MES",

          mes: Number(mes),

          ano: Number(ano),

          funcionarios: funcionariosIds,

          modelo: "CONTADOR",

        };

        const resp = await api.post(`/ponto/exportar`, payload, {

          responseType: "arraybuffer",

          headers: {

            Accept: getAcceptHeaderByFormato(fmt),

          },

        });

        const contentType =

          resp?.headers?.["content-type"] || "application/octet-stream";

        const filename =

          getFilenameFromDisposition(resp?.headers?.["content-disposition"]) ||

          `ponto_${ano}-${mes}_${exportAllMonth ? "todos" : funcionariosIds.join("-")}.${ext}`;

        downloadArrayBuffer({

          data: resp.data,

          contentType,

          filename,

        });

        openModal(

          "Exportação concluída",

          `Arquivo gerado e baixado com sucesso.\nFormato: ${fmt}\nEscopo: ${rotuloExportacao}\nCompetência: ${mes}/${ano}\nModelo: CONTADOR`,

          "success"

        );

      } catch (e) {

        console.error(e);

        let details = "";

        let msg = "Erro ao exportar ponto.";

        const buf = e?.response?.data;

        if (buf instanceof ArrayBuffer) {

          details = decodeArrayBufferToText(buf);

          try {

            const parsed = JSON.parse(details);

            msg = parsed?.mensagem || parsed?.message || parsed?.error || msg;

          } catch {

            if (details?.trim()) {

              msg = details.slice(0, 500);

            } else {

              msg = getErrMsg(e);

            }

          }

        } else {

          msg = getErrMsg(e);

        }

        openModal("Falha", msg, "error", details);

      } finally {

        setExporting(false);

      }

    },

    [

      codFunc,

      mes,

      ano,

      nomeFunc,

      exportAllMonth,

      selectedExportFuncs,

      carregarFuncionariosComRegistroNoMes,

      openModal,

      getErrMsg,

    ]

  );

  const canExport =

    !exporting &&

    (exportAllMonth || selectedExportFuncs.length > 0 || Boolean(codFunc));

  return (

    <MainLayout>

      <Modal

        open={modal.open}

        title={modal.title}

        message={modal.message}

        kind={modal.kind}

        details={modal.details}

        onClose={closeModal}

      />

      <div className="gestao-ponto-page">

        <div className="gp-header">

          <div className="gp-title">

            <h1>Gestão de Ponto</h1>

            <div className="gp-sub">

              Ajuste administrativo de horários por dia e exportação por competência.

            </div>

          </div>

          <div className="gp-actions">

            <button

              className="btn-small"

              onClick={loadMes}

              disabled={!codFunc || loading}

            >

              {loading ? "Carregando..." : "Recarregar"}

            </button>

            <div className="gp-export-group">

              <button

                className="btn-small btn-export-txt"

                onClick={() => exportar("TXT")}

                disabled={!canExport}

                title="Exportar TXT para o contador"

              >

                {exporting ? "Exportando..." : "TXT Contador"}

              </button>

              <button

                className="btn-small"

                onClick={() => exportar("XLSX")}

                disabled={!canExport}

                title="Exportar XLSX"

              >

                {exporting ? "Exportando..." : "Exportar XLSX"}

              </button>

              <button

                className="btn-primary"

                onClick={() => exportar("PDF")}

                disabled={!canExport}

                title="Exportar PDF"

              >

                {exporting ? "Exportando..." : "Exportar PDF"}

              </button>

            </div>

          </div>

        </div>

        <div className="gp-filters card">

          <div className="gp-row">

            <div className="field grow">

              <label>Funcionário</label>

              <SelectFuncionario value={func} onChange={setFunc} />

              <div className="muted" style={{ fontWeight: 700 }}>

                {codFunc

                  ? `CodFunc: ${codFunc}`

                  : "Selecione um funcionário para carregar o mês."}

              </div>

            </div>

            <div className="field inline">

              <label>Mês</label>

              <select value={mes} onChange={(e) => setMes(e.target.value)}>

                {Array.from({ length: 12 }, (_, i) => {

                  const mm = pad2(i + 1);

                  return (

                    <option key={mm} value={mm}>

                      {mm}

                    </option>

                  );

                })}

              </select>

            </div>

            <div className="field inline">

              <label>Ano</label>

              <select value={ano} onChange={(e) => setAno(e.target.value)}>

                {Array.from({ length: 6 }, (_, i) => {

                  const yy = String(now.getFullYear() - i);

                  return (

                    <option key={yy} value={yy}>

                      {yy}

                    </option>

                  );

                })}

              </select>

            </div>

            <div className="field grow">

              <label>Justificativa (obrigatória)</label>

              <input

                value={justificativa}

                onChange={(e) => setJustificativa(e.target.value)}

                placeholder="Ex.: ajuste autorizado pelo ADM / solicitação formal"

                disabled={!codFunc}

              />

            </div>

          </div>

          <div className="gp-row" style={{ marginTop: 12, alignItems: "flex-start" }}>

            <div className="field grow">

              <label>Fila de exportação</label>

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>

                <button

                  type="button"

                  className="btn-small"

                  onClick={addFuncionarioToExport}

                  disabled={!codFunc || exportAllMonth}

                >

                  Adicionar funcionário atual

                </button>

                <button

                  type="button"

                  className="btn-small"

                  onClick={clearExportSelection}

                  disabled={!selectedExportFuncs.length && !exportAllMonth}

                >

                  Limpar seleção

                </button>

                <label

                  style={{

                    display: "inline-flex",

                    alignItems: "center",

                    gap: 8,

                    fontWeight: 700,

                    cursor: "pointer",

                  }}

                >

                  <input

                    type="checkbox"

                    checked={exportAllMonth}

                    onChange={(e) => setExportAllMonth(e.target.checked)}

                  />

                  Todos com registro em {mes}/{ano}

                </label>

              </div>

              {!selectedExportFuncs.length ? (

                <div className="muted" style={{ fontWeight: 700 }}>

                  Nenhum funcionário adicionado à fila.

                </div>

              ) : (

                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>

                  {selectedExportFuncs.map((item) => (

                    <div

                      key={item.codFunc}

                      style={{

                        display: "inline-flex",

                        alignItems: "center",

                        gap: 8,

                        padding: "6px 10px",

                        borderRadius: 999,

                        border: "1px solid #d6d6d6",

                        background: "#fff",

                      }}

                    >

                      <span style={{ fontWeight: 700 }}>

                        {item.nome} ({item.codFunc})

                      </span>

                      <button

                        type="button"

                        className="btn-small"

                        onClick={() => removeFuncionarioFromExport(item.codFunc)}

                        disabled={exportAllMonth}

                      >

                        Remover

                      </button>

                    </div>

                  ))}

                </div>

              )}

              <div className="muted" style={{ marginTop: 8, fontWeight: 700 }}>

                Escopo atual da exportação:{" "}

                {exportAllMonth

                  ? `todos com registro em ${mes}/${ano}`

                  : selectedExportFuncs.length

                  ? `${selectedExportFuncs.length} funcionário(s) na fila`

                  : codFunc

                  ? `funcionário atual (${nomeFunc})`

                  : "nenhum selecionado"}

              </div>

            </div>

          </div>

        </div>

        <div className="gp-grid">

          <div className="card gp-table">

            <div className="gp-table__meta">

              <div>

                Competência <b>{mes}/{ano}</b>

              </div>

              <div className="muted">

                {loading ? "Carregando..." : `Dias: ${totalDias} | Registros: ${rowsMes.length}`}

              </div>

            </div>

            {!codFunc ? (

              <div className="muted" style={{ fontWeight: 800, padding: 10 }}>

                Selecione um funcionário.

              </div>

            ) : (

              <div className="gp-table__scroll">

                <table>

                  <thead>

                    <tr>

                      <th>Dia</th>

                      <th>Status</th>

                      <th>Ent. Manhã</th>

                      <th>Saí. Manhã</th>

                      <th>Ent. Tarde</th>

                      <th>Saí. Tarde</th>

                      <th>Ent. Extra</th>

                      <th>Saí. Extra</th>

                    </tr>

                  </thead>

                  <tbody>

                    {dias.map((d) => (

                      <tr

                        key={d.dia}

                        className={[

                          d.isWeekend ? "row-weekend" : "",

                          diaSel === d.dia ? "row-selected" : "",

                        ].join(" ")}

                        onClick={() => {

                          setDiaSel(d.dia);

                          cancelEdit();

                        }}

                        style={{ cursor: "pointer" }}

                      >

                        <td>{pad2(d.dia)}/{mes}</td>

                        <td>

                          <span className={`badge ${d.status.cls}`}>

                            {d.status.text}

                          </span>

                        </td>

                        <td>{d.row?.EntradaManha || "-"}</td>

                        <td>{d.row?.SaidaManha || "-"}</td>

                        <td>{d.row?.EntradaTarde || "-"}</td>

                        <td>{d.row?.SaidaTarde || "-"}</td>

                        <td>{d.row?.EntradaExtra || "-"}</td>

                        <td>{d.row?.SaidaExtra || "-"}</td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>

            )}

          </div>

          <div className="card gp-side">

            <div className="gp-side__title">Detalhe / Ações</div>

            {!diaAtual ? (

              <div className="muted" style={{ fontWeight: 800 }}>

                Selecione um dia na tabela.

              </div>

            ) : (

              <>

                <div className="gp-side__day">

                  Dia <b>{pad2(diaAtual.dia)}/{mes}/{ano}</b>

                  <span

                    className={`badge ${diaAtual.status.cls}`}

                    style={{ marginLeft: 10 }}

                  >

                    {diaAtual.status.text}

                  </span>

                </div>

                <div className="gp-side__list">

                  {CAMPOS.map((f) => {

                    const val = String(diaAtual.row?.[f.key] || "").slice(0, 5);

                    const editing = edit.campo === f.key;

                    return (

                      <div key={f.key} className={`gp-item ${editing ? "is-editing" : ""}`}>

                        <div className="gp-item__left">

                          <div className="gp-item__label">{f.label}</div>

                        </div>

                        <div className="gp-item__mid">

                          {editing ? (

                            <input

                              type="time"

                              value={edit.valor}

                              onChange={(e) =>

                                setEdit((s) => ({ ...s, valor: e.target.value }))

                              }

                              disabled={saving}

                            />

                          ) : (

                            <div className="gp-item__value">{val || "-"}</div>

                          )}

                        </div>

                        <div className="gp-item__right">

                          {!editing ? (

                            <button

                              className="btn-small"

                              onClick={() => startEdit(f.key)}

                              disabled={!codFunc}

                            >

                              Ajustar

                            </button>

                          ) : (

                            <div className="gp-actions-inline">

                              <button

                                className="btn-primary"

                                onClick={save}

                                disabled={saving}

                              >

                                {saving ? "Salvando..." : "Salvar"}

                              </button>

                              <button

                                className="btn-small"

                                onClick={cancelEdit}

                                disabled={saving}

                              >

                                Cancelar

                              </button>

                            </div>

                          )}

                        </div>

                      </div>

                    );

                  })}

                </div>

                <div className="muted" style={{ marginTop: 10, fontWeight: 800 }}>

                  Governança: justificativa obrigatória. Se existir ID no dia → PATCH

                  (auditoria). Se falhar → fallback PUT. Se não existir → PUT (cria).

                </div>

              </>

            )}

          </div>

        </div>

      </div>

    </MainLayout>

  );

}
